module.exports = __webpack_public_path__ + "static/media/290629.6b70f09b.png";